import axiosInstance from 'axiosInstance';

export const fetchPartnerDashboard = async () => {
  const response = await axiosInstance.get('waitlist/partner-dashboard');
  return response.data;
};
